import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import Dashboard from "../../common/components/layout/Dashboard";
import { InvoiceTable } from "./InvoiceTable.page";

function InvoicePage() {
  return (
    <ToastProvider>
      <Dashboard>
        <InvoiceTable />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}

export default InvoicePage;
